module.exports = __webpack_public_path__ + "static/img/pic3.720beb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/home/pic3.png
// module id = 70j2
// module chunks = 20